import type { Lead } from "src/types/lead";

const normalizeName = (s: string | null | undefined) => (s || "").trim().toLowerCase();
const normalizeEmail = (s: string | null | undefined) => (s || "").trim().toLowerCase();
const normalizePhone = (s: string | null | undefined) => (s || "").replace(/\D/g, "");

export function isMergeCandidate(target: Lead, source: Lead): boolean {
  if (!target?.extracted || !source?.extracted) return false;
  if (source.id === target.id) return false;
  if (source.isTest || target.isTest) return false;

  const tPhone = normalizePhone(target.extracted.phone);
  const sPhone = normalizePhone(source.extracted.phone);

  const tEmail = normalizeEmail(target.extracted.email);
  const sEmail = normalizeEmail(source.extracted.email);

  const tLast = normalizeName(target.extracted.last_name);
  const sLast = normalizeName(source.extracted.last_name);

  const phoneMatch = tPhone.length >= 10 && sPhone.length >= 10 && tPhone === sPhone;
  const emailMatch = !!tEmail && !!sEmail && tEmail === sEmail;
  const phoneLastMatch = phoneMatch && !!tLast && !!sLast && tLast === sLast;

  return phoneMatch || emailMatch || phoneLastMatch;
}